module.exports = __webpack_public_path__ + "a3474ed2bc45b7bc201161b1d00f814d.svg";